import { useState, useContext, useEffect } from "react";
import { Heart } from "lucide-react";
import { MasajidContext } from "../contexts/MasajidContext";

function FavouriteButton({ username }) {
  const { toggleFavourite, isFavourite, language } = useContext(MasajidContext);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const isFav = isFavourite(username);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggle = () => {
    toggleFavourite(username);
    setIsAnimating(true);
    setTimeout(() => setIsAnimating(false), 300);
  };

  const buttonText = {
    remove:
      language === "urdu"
        ? "پسندیدہ مساجد سے ہٹائیں"
        : "Remove from Favourites",
    set:
      language === "urdu" ? "پسندیدہ مساجد میں شامل کریں" : "Add to Favourites",
  };

  const showText = !isMobile;

  return (
    <button
      onClick={handleToggle}
      style={{
        background: isFav ? "rgba(230, 57, 70, 0.3)" : "rgba(230, 57, 70, 0.1)",
        border: "3px solid #e63946",
        borderRadius: "24px",
        padding: isMobile ? "10px 12px" : "12px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        cursor: "pointer",
        transition: "background 0.3s ease, transform 0.3s ease",
        fontSize: "16px",
        fontWeight: "600",
        color: "rgb(255, 255, 255, 0.9)",
        width: "100%",
        boxSizing: "border-box",
        transform: isAnimating ? "scale(1.05)" : "scale(1)",
      }}
      aria-label={isFav ? buttonText.remove : buttonText.set}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: showText ? "6px" : "0",
          minWidth: showText ? "100px" : "auto",
        }}
      >
        <Heart
          size={20}
          color={isFav ? "#e63946" : "rgb(255, 255, 255, 0.6)"}
          fill={isFav ? "#e63946" : "none"}
          strokeWidth={2}
          style={{ flexShrink: 0 }}
        />
        {showText && (
          <span
            style={{ whiteSpace: "nowrap" }}
            lang={language === "urdu" && "ur"}
          >
            {isFav ? buttonText.remove : buttonText.set}
          </span>
        )}
      </div>
    </button>
  );
}

export default FavouriteButton;
